import {IAudioConfig} from '@gongxigames/framework/slot';

/**
 * Use /soundType/ in order to insert text in source of sound or music
 */
const gameSoundConfig = {
    defaultPriority: {
        winSingle: 'modern_hit',
        maingameloopintro: 'basic_maingameintro',
        rubySymbolStop: 'rubyfeature_symbolstop',
        rubySymbolMove: 'rubyfeature_symbolmove',
        picktrigger: 'wh_pickbonustrigger',
        wildactivator: 'wh_wildactivator',
        wildactivatormove: 'wh_wildmove',
        wildactivatorappear: 'wh_wildappear',
        activatorhit: 'wh_wildactivatorhit',
        buyBonusTrigger: 'buybonus_trigger',
        rubyBannerUp: 'rubyfeature_bannerup',
        rubyBannerDown: 'rubyfeature_bannerdown'
    },
    afterPriority: {
        diamondflight: 'wh_gemmove',
        gemfill: 'wh_gemfill',
        coinclick: 'wh_medallionreveal',
        pickAward: 'wh_pickbonusaward',
        freegameend: 'basic_freegameend',
        picktrigger: 'wh_pickbonustrigger'
    }
};
const gameMusicConfig = {
    defaultPriority: {},
    afterPriority: {
        freegamewaitingloop: 'basic_freegamewaiting',
        pickloop: 'wh_pickingloop'
    }
};

export const gameAudioConfig: IAudioConfig = {
    soundConfig: gameSoundConfig,
    musicConfig: gameMusicConfig,
    soundType: 'generic',
    properties: {
        modern_hit: {
            panning: 0,
            volume: 50
        },
        basic_betbuttondown: {
            panning: 0
        },
        basic_betbuttonmaxbet: {
            panning: 0
        },
        basic_betbuttonup: {
            panning: 0
        },
        basic_reelstop1: {
            panning: 0
        },
        basic_reelstop2: {
            panning: 0
        },
        basic_reelstop3: {
            panning: 0
        },
        basic_reelstop4: {
            panning: 0
        },
        basic_reelstop5: {
            panning: 0
        },
        basic_reelstop6: {
            panning: 0
        },
        basic_spinclick: {
            panning: 0
        },
        basic_uitbuttonclick: {
            panning: 0
        },
        basic_uitogglebutton: {
            panning: 0
        },
        gxg_generic_bigwin: {
            panning: 0
        },
        gxg_generic_bigwin_end: {
            panning: 0
        },
        gxg_generic_win1a: {
            panning: 0
        },
        gxg_generic_win1b: {
            panning: 0
        },
        gxg_generic_win2: {
            panning: 0
        },
        gxg_generic_win2b: {
            panning: 0
        },
        gxg_generic_win3: {
            panning: 0
        },
        gxg_generic_win3b: {
            panning: 0
        },
        gxg_generic_win4: {
            panning: 0
        },
        gxg_generic_win4b: {
            panning: 0
        },
        gxg_generic_win5: {
            panning: 0
        },
        gxg_generic_win6: {
            panning: 0
        },
        rubyfeature_bannerdown: {
            panning: 0
        },
        rubyfeature_bannerup: {
            panning: 0
        },
        rubyfeature_symbolmove: {
            panning: 0
        },
        rubyfeature_symbolstop: {
            panning: 0
        },
        basic_bannertransitionenter: {
            panning: 0
        },
        basic_bannertransitionexit: {
            panning: 0
        },
        basic_freegameend: {
            panning: 0
        },
        basic_freegameloop: {
            panning: 0
        },
        basic_freegamewaiting: {
            panning: 0
        },
        basic_freespintrigger: {
            panning: 0
        },
        basic_hyperspin: {
            panning: 0
        },
        basic_maingameloop: {
            panning: 0
        },
        basic_premonition: {
            panning: 0
        },
        basic_quickstop2scatter: {
            panning: 0
        },
        basic_quickstop3ormorescatter: {
            panning: 0
        },
        basic_scatterhit1: {
            panning: 0
        },
        basic_scatterhit2: {
            panning: 0
        },
        basic_scatterhit3: {
            panning: 0
        },
        basic_scatterhit4: {
            panning: 0
        },
        basic_scatterhit5: {
            panning: 0
        },
        buybonus_trigger: {
            panning: 0
        },
        wh_gemfill: {
            panning: 0
        },
        wh_gemmove: {
            panning: 0
        },
        wh_medallionreveal: {
            panning: 0
        },
        wh_pickbonusaward: {
            panning: 0
        },
        wh_pickbonustrigger: {
            panning: 0
        },
        wh_pickingloop: {
            panning: 0
        },
        wh_wildactivator: {
            panning: 0
        },
        wh_wildactivatorhit: {
            panning: 0
        },
        wh_wildappear: {
            panning: 0
        },
        wh_wildmove: {
            panning: 0
        }
    }
};
